// extracted by mini-css-extract-plugin
module.exports = {"root":"Control_root_3d35k","button":"Control_button_2Ggq4","text":"Control_text_3HWAI"};